module.exports = require("aws-sdk");


//////////////////
// WEBPACK FOOTER
// external "aws-sdk"
// module id = 17
// module chunks = 0